import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1em;

    .title {
        font-weight: 600;
        font-size: 1.3em;
    }

    .controls {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .layout-button {
            .button {
                padding: 0;
            }
        }
    }

    @media all and (max-width: ${variables.tabletL}) {}
`;